import CustomButton from "../../../../../components/CustomButton";
import userRoles from "../../../../../constants/userRoles";
import SvgIcon from "../../../../../helpers/SvgIcon";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { postDeleteUser } from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { removeUserFromUsers } from "../../../../../redux/reducer/admin.reducer";
import { adminRoutes } from "../../../../../router/routesConstants";
import usePermissions from "../../../../../router/usePermissions";

function UsersActionButton({ itemId, crudData, tableContext }: any) {
  const dispatch = useAppDispatch();

  const { isAuthorized } = usePermissions();

  const ADMINISTRATE_ROLES_AND_NODES = isAuthorized(
    userRoles.ADMINISTRATE_ROLES_AND_NODES,
  );

  const handleDeleteUser = async () => {
    const resultAction = await dispatch(postDeleteUser({ userId: itemId }));

    if (
      checkEndpointStatus(resultAction, postDeleteUser) ===
      endpointStatus.fulfilled
    ) {
      if (
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage
      ) {
        dispatch(removeUserFromUsers(itemId));
      }
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        tooltipTitle="Editeaza utilizator"
        className="mt-1 me-1"
        navigate={`/${adminRoutes.users}/${adminRoutes.editUser}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`}>
        <SvgIcon type="EDIT" />
      </CustomButton>

      <CustomButton
        variant="contained"
        tooltipTitle="Roluri web"
        className="mt-1 me-1"
        navigate={`/${adminRoutes.users}/${adminRoutes.adminUserWebRoles}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`}>
        <SvgIcon type="WEB_ROLES" fill="white" className="svg-icon-2" />
      </CustomButton>
      <CustomButton
        variant="contained"
        tooltipTitle="Roluri palm"
        className="mt-1 me-1"
        navigate={`/${adminRoutes.users}/${adminRoutes.adminUserMobileRoles}?userId=${itemId}&firstName=${crudData.prenume}&secondName=${crudData.nume}`}>
        <SvgIcon type="PALM_ROLES" fill="white" className="svg-icon-2" />
      </CustomButton>

      {ADMINISTRATE_ROLES_AND_NODES && (
        <CustomButton
          variant="contained"
          tooltipTitle="Functii si noduri"
          className="mt-1 me-1"
          navigate={`/${adminRoutes.users}/${adminRoutes.rolesAndNodes}?userId=${itemId}&userName=${crudData.username}`}>
          <SvgIcon
            type="ROLES_AND_FUNCTIONS"
            fill="white"
            className="svg-icon-2"
          />
        </CustomButton>
      )}

      <CustomButton
        variant="contained"
        tooltipTitle="Stergere"
        color="error"
        className="mt-1 me-1"
        withConfirmationModal={{
          modalTitle: "Stergere utilizator",
          modalSubtitle: `Doriti sa stergeti utilizatorul: ${crudData.nume} ${crudData.prenume}?`,
          modalLeftButtonVariant: "outlined",
          modalRightButtonOnClick: handleDeleteUser,
        }}>
        <SvgIcon type="DELETE" />
      </CustomButton>
    </div>
  );
}

export default UsersActionButton;
